<template>
  <section class="section solution">
    <div class="columns">
      <!-- -->
      <div class="column key">
        <p>
          <strong>1.8%</strong>
          <br class="is-hidden-mobile" />месечна лихва
        </p>
        <span class="tag info">изгодни персонални оферти</span>
      </div>
      <!-- -->
      <div class="column key">
        <!-- <p>
          <strong>Независимо</strong> от
          <br class="is-hidden-mobile" />кредитната ви история
        </p> -->
        <p>
          <span>Фирмен Кредит</span>
          <br class="is-hidden-mobile" /><strong>Независимо от кредитната ви история</strong>
        </p>
      </div>
      <!-- -->
      <div class="column key">
        <p>
          <strong>Одобрихме</strong>
          <br class="is-hidden-mobile" />повечето заявки
        </p>
        <span class="tag offer">над 82% за последния месец</span>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'OpeningBullets'
}
</script>

<style lang="stylus" scoped>
.section {
  padding: 36px 0;
  background: #EEF3F2;

  .column {
    padding: auto;
  }

  .key {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0;
  }

  .tag {
    margin-top: 5px;
    box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1), inset 0 0 0 1px rgba(0, 0, 0, 0.1);
    font-weight: 500;
    font-size: 0.8rem;

    &.offer {
      background: lime + 64%;
      color: green + 0%;
    }

    &.info {
      // background: #43A2E6 + 15%;
      // color: white;
      background: #43A2E6 + 64%;
      color: blue - 10%;
    }
  }

  p {
    font-size: 1.1rem;
  }
}

// @MEDIA
// <<< 768px
@media (max-width: 768px) {
  .section {
    padding: 14px 36px;
    background: white;

    .column {
      padding: 20px 0;
      // .column:not(:last-child)
      border-bottom: 1px solid rgba(#45A1E5, 0.5);
    }

    .key {
      // align-content center
      // justify-content: flex-start
      align-items: flex-start;

      p {
        align-self: flex-start;
        text-align: left;
      }
    }
  }
}

// 769px >>>
@media (min-width: 769px) {
  .column:not(:last-child) {
    // background wheat
    border-right: 2px solid rgba(#45A1E5, 0.9);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/OpeningBullets.vue